import CryptoJS from 'crypto-js'

export function encrypt(data, secretKey) {
    return CryptoJS.AES.encrypt(data, secretKey).toString()
}

export function decrypt(ciphertext, secretKey) {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
        return bytes.toString(CryptoJS.enc.Utf8)
    } catch (error) {
        return ''
    }
}
